import request from '@/utils/request'
import request_all from "@/utils/request_all";
// 进行审核操作  测试用
// export function temp(data) {
// 	return request({
// 		url: `/api/approve/request/42/approve/`,
// 		method: 'post',
// 		data
// 	})
// }
// 根据报表索引, 获取报表详情条目 临时用
// export function temp2() {
// 	return request({
// 		url: `/api/report/367/`,
// 		method: 'get',
// 	})
// }
// 内部用户退出登录 不用接口形式  直接访问url
// export function logout() {
// 	return request({
// 		url: `/auth/logout/`,
// 		method: 'get',
// 	})
// }
export function get_topic() {
	return request({
		url: `/api/approve/research-topic/?pageSize=999&pageNum=1`,
		method: "get"
	});
}
// 调查问卷
export function getQuestion() {
	return request({
		url: `/api/report/questionnaire/`,
		params: {
			pageNum: 1,
			pageSize: 1000
		}
	});
}
// 下载文件
export function download_file(params) {
	return request_all({
		url: `/api/carousel/download-file`,
		method: "get",
		params,
		responseType: 'blob',
	});
}
export function download_excel(id, data_type) {
	return request_all({
		url: `/api/approve/${id}/reports/?export=true&data_type=${data_type}`,
		method: "get",
		responseType: 'blob',
		timeout: 10 * 60 * 1000
	});
}
// 相关成果文章
export function get_achievement(params) {
	// is_staff_req 如果是vue来查询，就传true，返回所有数据 这是临时方案 后面权限加进来再改
	// params.is_staff_req=true
	return request({
		url: "/api/article/achievement/",
		method: "get",
		params
	});
}
export function get_achievement_id(id) {
	return request({
		url: `/api/article/achievement/${id}/`,
		method: "get"
	});
}
// 相关成果分类
export function getAchievementType(params) {
	return request({
		url: `/api/article/article-type-achievement/`,
		params
	});
}
// 获取申请模板文件
export function getApproveFile() {
	return request({
		url: `/api/approve/approve-request-file/`,
	})
}
// 获取首页地图数据
export function province_interviewee() {
	return request({
		url: `/api/report/province_interviewee/`,
		method: 'get',
	})
}
// 获取首页柱状图数据
export function year_interviewee() {
	return request({
		url: `/api/report/year_interviewee/`,
		method: 'get',
	})
}
// 获取用户来源下拉数据
export function user_type(params) {
	return request({
		url: `/api/user/user-type/`,
		method: 'get',
		params
	})
}
// 清缓存  后台cookie加了httpOnly前端清除不了
export function logout() {
	return request({
		url: `/admin/logout/`,
		method: 'post',
	})
}
// 用户信息
export function user_info() {
	return request({
		url: `/api/user/info/`,
		method: 'get',
	})
}
// 授权申请详情
export function report_detail(params, id) {
	return request({
		url: `/api/approve/${id}/reports/`,
		method: 'get',
		params
	})
}
// 系统信息
export function system_introduce() {
	return request({
		url: `/api/user/system-introduce/`,
		method: 'get',
	})
}
// 用户协议
export function user_agreement(params) {
	return request({
		url: `/api/user/user-agreement/`,
		method: 'get',
		params
	})
}
// 授权申请列表
export function get_approve_list(params) {
	return request({
		url: '/api/approve/request/',
		method: 'get',
		params
	})
}
// 进行数据报表授权申请
export function post_approve(data) {
	return request({
		url: '/api/approve/request/',
		method: 'post',
		data
	})
}
// 获取所有省对应的code
export function area_code() {
	return request({
		url: `/api/area/area/`,
		method: 'get',
	})
}
// 根据查询条件, 筛选报表维度(下拉数据) 其他数据需要先选择年份
export function queryIndex(data) {
	return request({
		url: '/api/report/query-index/',
		method: 'post',
		data
	})
}
// 获取地区维度
export function area_group(years, data_type) {
	return request({
		url: `/api/area/area_group/?years=${years}&not_page=true&data_type=${data_type}`,
		method: 'get',
	})
}

// 获取验证码
export function get_code(params) {
	return request({
		url: `/api/sms/sms-code/`,
		method: 'get',
		params
	})
}

// /* 
// 注册
// */
// export function userReg(data) {
//   return request({
//     url: '/api/user/user-reg/',
//     method: 'post',
//     data
//   })
// }
/* 
登陆
*/
export function login(data) {
	return request({
		url: '/admin/api-token-auth/',
		method: 'post',
		data
	})
}
/* 
登陆和注册  phone=>手机号 action=>区分登陆和注册 没有注册，没有就会自动创建一个用户
*/
export function loginReg(data) {
	return request({
		url: '/api/sms/sms-code/',
		method: 'post',
		data
	})
}
/* 
轮播图
*/
export function carousel() {
	return request({
		url: '/api/carousel/carousel/',
		method: 'get',
		params: {
			is_active: true
		}
	})
}
/* 
文章列表
*/
export function articleList(params) {
	return request({
		url: '/api/article/article/',
		method: 'get',
		params
	})
}
